import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { apiGet } from '../../lib/api';
import { FileText } from 'lucide-react';

export default function CustomerBills() {
  const [list, setList] = useState([]);
  const { selectedCustomerId, loadingProviders } = useOutletContext() || {};
  useEffect(() => {
    if (loadingProviders) return;
    const query = selectedCustomerId ? `?customer_id=${selectedCustomerId}` : '';
    apiGet(`/customer/invoices${query}`).then(r => setList(r.data || [])).catch(() => {});
  }, [selectedCustomerId, loadingProviders]);
  return (
    <div className="space-y-3" data-testid="cust-bills">
      <h1 className="font-heading font-bold text-2xl text-rozops-navy">My bills</h1>
      {list.length === 0 && <div className="bg-white rounded-2xl border border-gray-100 p-6 text-center text-rozops-text-muted">No bills yet.</div>}
      {list.map(i => (
        <div key={i.id} className="bg-white rounded-2xl border border-gray-100 shadow-soft p-5">
          <div className="flex items-center justify-between">
            <div>
              <div className="font-heading font-bold text-rozops-navy flex items-center gap-2"><FileText className="w-4 h-4 text-rozops-blue" /> {i.invoice_number}</div>
              {i.provider?.business?.business_name && <div className="text-xs text-rozops-text-muted">{i.provider.business.business_name}</div>}
              <div className="text-xs text-rozops-text-muted">{i.billing_start_date} → {i.billing_end_date}</div>
            </div>
            <div className="text-right">
              <div className="font-heading font-extrabold text-lg text-rozops-navy">₹{Number(i.total_amount).toFixed(2)}</div>
              <div className={`text-xs font-bold ${i.status === 'paid' ? 'text-rozops-green' : 'text-red-500'}`}>{i.status === 'paid' ? 'Paid' : `Due ₹${Number(i.due_amount).toFixed(2)}`}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
